import type { DayState } from '@daily/shared';
import { dayStateTheme } from '@/lib/dayStateTheme';

export function Ambient({ dayState }: { dayState: DayState }) {
  const theme = dayStateTheme[dayState];
  return (
    <div
      className="fixed inset-0 pointer-events-none -z-10 transition-opacity duration-700"
      style={{ background: theme.ambientGradient }}
    />
  );
}
